/* eslint-disable */
export default {
  noActiveCalls: 'Geen actieve oproepen',
  noCalls: 'Geen resultaten gevonden.',
  currentCall: 'Huidige oproep',
  ringCall: 'Overgaande oproep',
  onHoldCall: 'Oproep staat in de wacht',
  historyCalls: 'Eerdere oproepen',
  otherDeviceCall: 'Actieve oproepen op mijn andere apparaten',
  searchPlaceholder: 'Zoeken...',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noCalls"@#@ @source: @#@"No results found."@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"historyCalls"@#@ @source: @#@"Past Calls"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"searchPlaceholder"@#@ @source: @#@"Search..."@#@
